import React from 'react';
import styled from 'styled-components';
import {css} from 'emotion';
import Row from './Row';

import adarsh from '../assets/img/adarsh.png'
import praneesha from '../assets/img/praneesha.png'
import ravi from '../assets/img/ravi.png'

/* global tw */

const Section = styled.section`
    ${tw`flex flex-wrap w-screen h-auto py-20 lg:py-28 items-start relative z-0`};
    background: #0A0A0F;
    background-image:
        radial-gradient(ellipse 50% 40% at 100% 0%, rgba(170,11,202,0.1), transparent 70%),
        radial-gradient(ellipse 40% 30% at 0% 100%, rgba(125,14,222,0.08), transparent 70%);
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
`

const SectionHeading = styled.h2`
    ${tw`mb-10 ml-2 w-full`};
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    font-weight: 800;
    color: #F5F5F7;
    letter-spacing: -0.04em;
    line-height: 1.1;
    font-size: 2rem;
    margin-top: 0;
    @media (min-width: 992px){
        font-size: 2.75rem;
    }
    &::before {
        content: 'TESTIMONIALS';
        display: block;
        text-transform: uppercase;
        letter-spacing: 0.12em;
        font-size: 0.6875rem;
        font-weight: 700;
        color: #CB53D1;
        margin-bottom: 0.875rem;
    }
    &::after {
        content: '';
        display: block;
        margin-top: 0.875rem;
        height: 2px;
        width: 2.5rem;
        background: #C9A84C;
        border-radius: 2px;
    }
`

const TestimonalWrapper = styled.div`
    ${tw`flex flex-wrap items-start px-8 mx-auto lg:mx-2 my-3 w-full lg:w-1/4`};
    background: #1A1A24;
    border: 1px solid rgba(170, 11, 202, 0.2);
    border-radius: 6px;
    min-height: 15rem;
    height: auto;
    box-shadow: 0 8px 32px rgba(0,0,0,0.3);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    &::before {
        content: '"';
        position: absolute;
        top: -1.5rem;
        left: 1.25rem;
        font-size: 8rem;
        font-family: Georgia, serif;
        color: rgba(170, 11, 202, 0.12);
        line-height: 1;
        pointer-events: none;
    }
    &:hover {
        transform: translateY(-6px);
        box-shadow: 0 20px 56px rgba(170, 11, 202, 0.18);
        border-color: rgba(170, 11, 202, 0.4);
    }
    p {
        ${tw`py-10 text-sm lg:text-normal`};
        font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
        font-weight: 500;
        line-height: 1.7;
        color: rgba(255,255,255,0.75);
        font-size: 1rem;
        position: relative;
        z-index: 1;
    }
    &:nth-of-type(even) {
        @media(min-width: 992px){
            margin-top: 4rem;
        }
    }
`

const StarRow = styled.div`
    display: flex;
    gap: 3px;
    margin-bottom: 0.25rem;
    color: #C9A84C;
    font-size: 0.875rem;
`

const User = styled.div`
    ${tw`flex items-center w-full py-5`};
    border-top: 1px solid rgba(170, 11, 202, 0.15);
`

const UserPic = styled.div`
    ${tw`relative rounded-full overflow-hidden mr-3 lg:mr-4 flex-shrink-0`};
    height: 3rem;
    width: 3rem;
    background-image: ${props => `url(${props.image})`};
    background-size: cover;
    background-repeat: no-repeat;
    border: 2px solid rgba(170, 11, 202, 0.3);
    box-shadow: 0 2px 8px rgba(0,0,0,0.3);
`

const UserName = styled.p`
    ${tw`my-1 py-0`};
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    font-weight: 700;
    font-size: 1rem;
    color: #F5F5F7;
    line-height: 1.1;
    letter-spacing: -0.01em;
`

const UserCity = styled.p`
    ${tw`my-0 py-0`};
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    font-weight: 500;
    font-size: 0.75rem;
    color: #CB53D1;
    line-height: 1.1;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin-top: 2px;
`

class SectionFour extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            testimonials: [
                {
                    text: "Zyppys saves me more time and money every time I travel in a rented car. This is such a life saver :)",
                    name: "Adarsh",
                    image: adarsh,
                    city: 'Bengaluru',
                },
                {
                    text: "To be able to know for sure that you are getting the best deal out of everything and you don't have to look back again is priceless!",
                    name: "Praneesha",
                    image: praneesha,
                    city: 'Hyderabad',
                },
                {
                    text: "Zyppys makes it so easy to rent a car. I also love the reward points. I've always been able to find a great deal for all three of my last car rentals!",
                    name: "Ravi",
                    image: ravi,
                    city: 'Chennai',
                },
            ],
        };
    }

    render() {
        return (
            <Section>
                <Row justifyBetween className={css`${tw`relative z-50`}`}>
                    <SectionHeading>What People Say?</SectionHeading>
                    {this.state.testimonials.map((obj, key) =>
                        <TestimonalWrapper key={key}>
                            <StarRow>★★★★★</StarRow>
                            <p>{obj.text}</p>
                            <User>
                                <UserPic image={obj.image} />
                                <div>
                                    <UserName>{obj.name}</UserName>
                                    <UserCity>{obj.city}</UserCity>
                                </div>
                            </User>
                        </TestimonalWrapper>
                    )}
                </Row>
            </Section>
        );
    }
}

export default SectionFour;
